/**
 * NavButtons - Boutons de navigation cohérents dans toute l'application.
 *
 * - BackButton : "Retour" = vrai historique navigateur (navigate(-1)).
 *   Remonte exactement à l'écran précédent (avec ses filtres/onglets/scroll via l'URL).
 *   Si aucun historique interne n'existe (entrée directe), repli vers `fallback`.
 * - OverviewButton : "Vue d'ensemble" = retour direct au Dashboard principal.
 */

import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft, LayoutDashboard } from 'lucide-react';

// react-router v7 stocke l'index d'historique dans window.history.state.idx
export function canGoBack() {
    try {
        return (window.history.state?.idx ?? 0) > 0;
    } catch {
        return false;
    }
}

export function BackButton({
    fallback = '/dashboard',
    label = 'Retour',
    className = '',
    testid = 'back-btn',
    size = 'sm',
}) {
    const navigate = useNavigate();
    const handle = () => {
        if (canGoBack()) navigate(-1);
        else navigate(fallback);
    };
    return (
        <Button variant="ghost" size={size} onClick={handle} data-testid={testid}
            className={`text-slate-600 hover:text-slate-900 ${className}`}>
            <ArrowLeft className="w-4 h-4 mr-1" />
            <span className="hidden sm:inline">{label}</span>
        </Button>
    );
}

export function OverviewButton({
    to = '/dashboard',
    label = "Vue d'ensemble",
    className = '',
    testid = 'overview-btn',
    size = 'sm',
}) {
    const navigate = useNavigate();
    return (
        <Button variant="outline" size={size} onClick={() => navigate(to)} data-testid={testid}
            className={`gap-1 ${className}`}>
            <LayoutDashboard className="w-4 h-4" />
            <span className="hidden sm:inline">{label}</span>
        </Button>
    );
}
